import React, { Component } from "react";
import icon_death from "../images/icone-death.svg";
import icon_biometric from "../images/icone-biometric-invalid.svg";
import icon_cpf from "../images/icone-cpf-invalido.png";
import icon_error_data from "../images/icone-error-document.svg";
import icon_session_expired from "../images/icone_sessao_expirada.svg";
import icon_block from "../images/icone-block.png";
import icon_deleted from "../images/doc_excluido-02.svg";
import icon_maintenance from "../images/atualizacao-02.svg";
import icone_atencao from "../images/icone_atencao.png";
import Header from "../components/Header.js";
import icon_doc_not_sign from "../images/icone-doc-nao-assinado.svg";
import RedirectAuthenticate from "../components/RedirectAuthenticate.js";

class ErrorGeneric extends Component {
  verifyPopUp() {
    window.opener.postMessage([true, this.props.keyCallback], "*");
    window.close();
  }

  render() {
    const {
      biometricInvalid,
      cpfInvalid,
      death,
      block,
      dataInvalid,
      lastVerification,
      continueVerification,
      sessionExpired,
      reloadSystem,
      authenticationNotPermited,
      deletedDoc,
      inMaintenance,
      authentication,
      urlRedirect,
      selfieInvalid,
      connectionInterrupted,
      cancel,
      accessCam,
      limitAccess,
      geolocationNeeded,
      logo,
      expiredDoc,
      arrestWarrant,
      personPoliticallyExports,
      docBlocked,
      customMessage,
      urlInvalid,
    } = this.props;

    return (
      <div className="container h-100">
        <div className="row text-center px-4" style={{ minHeight: "calc(100vh - 106px)" }}>
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2 mt-5">
            {urlInvalid && (
              <>
                <img src={icon_error_data} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <h1 className="card-title fw-bold text-white mt-5">DADOS NÃO CONFEREM</h1>
                {<h5 className="card-text text-light">Procure a pessoa ou instituição que precisa da sua assinatura para continuar o processo.</h5>}
                {urlRedirect && <RedirectAuthenticate urlRedirect={urlRedirect} />}
              </>
            )}
            {death && (
              <>
                <img src={icon_death} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <h1 className="card-title fw-bold text-white mt-5">TITULAR FALECIDO</h1>
                <h5 className="card-text text-light">Identificamos uma certidão de óbito nesse CPF.</h5>
                {urlRedirect && <RedirectAuthenticate urlRedirect={urlRedirect} />}
              </>
            )}
            {biometricInvalid && (
              <>
                <img src={icon_biometric} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <h1 className="card-title fw-bold text-white mt-5">{customMessage ? customMessage : "RECONHECIMENTO FACIAL INCONSISTENTE"}</h1>
                <h5 className="card-text text-light">
                  {customMessage
                    ? "Para sua segurança, vá até um cartório de Registro Civil e atualize sua biometria facial."
                    : "Não foi possível validar a sua biometria facial com a nossa base de dados."}
                </h5>
                {urlRedirect && <RedirectAuthenticate urlRedirect={urlRedirect} />}
              </>
            )}
            {cpfInvalid && (
              <>
                <img src={icon_cpf} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <h1 className="card-title fw-bold text-white mt-5">DADOS NÃO CONFEREM</h1>
                {!authentication && <h5 className="card-text text-light">Procure a pessoa ou instituição que precisa da sua assinatura para continuar o processo.</h5>}
                {urlRedirect && <RedirectAuthenticate urlRedirect={urlRedirect} />}
              </>
            )}
            {dataInvalid && (
              <>
                <img src={icon_error_data} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <h1 className="card-title fw-bold text-white mt-5">DADOS NÃO CONFEREM</h1>
                {!authentication && <h5 className="card-text text-light">Procure a pessoa ou instituição que precisa da sua assinatura para continuar o processo.</h5>}
                {urlRedirect && <RedirectAuthenticate urlRedirect={urlRedirect} />}
              </>
            )}
            {block && (
              <>
                <Header logo={logo} />
                <img src={icon_block} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <h1 className="card-title fw-bold text-white">ACESSO BLOQUEADO</h1>
                <h5 className="card-text text-light">
                  Desculpe, você ultrapassou o número de tentativas para fazer o seu cadastro. Esta é uma medida de segurança.{" "}
                  {!authentication
                    ? `Procure a pessoa
                  ou a instituição que precisa da sua assinatura para continuar o
                  processo.`
                    : ""}
                </h5>
                {urlRedirect && <RedirectAuthenticate urlRedirect={urlRedirect} />}
              </>
            )}
            {lastVerification && (
              <>
                <Header logo={logo} />
                <h1 className="card-title fw-bold text-danger mt-5">ATENÇÃO</h1>
                <h4 className="card-text text-danger">Percebemos que você já interrompeu o processo mais de uma vez. Seu acesso poderá ser bloqueado. Esta é sua última tentativa.</h4>
                <div className="row mt-5 justify-content-center">
                  <div className="col-12 d-grid mt-5 ">
                    <button type="button" className="btn btn-primary btn-sm fw-bold" onClick={continueVerification}>
                      PROSSEGUIR
                    </button>
                  </div>
                </div>
              </>
            )}
            {!block &&
              !lastVerification &&
              !sessionExpired &&
              !inMaintenance &&
              !authenticationNotPermited &&
              !deletedDoc &&
              !expiredDoc &&
              !authentication &&
              !selfieInvalid &&
              !connectionInterrupted &&
              !cancel &&
              !accessCam &&
              !limitAccess &&
              !geolocationNeeded &&
              !arrestWarrant &&
              !docBlocked &&
              !urlInvalid && (
                <div className="row mt-5 justify-content-center">
                  <div className="col-12 d-grid mt-5 ">
                    <a href={process.env.REACT_APP_HELP_URL} target="_blank" className="btn btn-primary fw-bold mt-5">
                      AJUDA
                    </a>
                  </div>
                </div>
              )}
            {deletedDoc && (
              <>
                <Header logo={logo} />
                <img src={icon_deleted} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <h1 className="card-title fw-bold text-white mt-5">DOCUMENTO EXCLUÍDO, RECUSADO OU INATIVADO</h1>
                <h5 className="card-text text-light">Este documento foi deletado, recusado ou está inativo no sistema. Procure a empresa que precisa da sua assinatura.</h5>
              </>
            )}
            {docBlocked && (
              <>
                <Header logo={logo} />
                <img src={icon_block} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <h1 className="card-title fw-bold text-white mt-5">DOCUMENTO BLOQUEADO</h1>
                <h5 className="card-text text-light">Este documento encontra-se bloqueado. Procure a empresa que precisa da sua assinatura.</h5>
              </>
            )}
            {expiredDoc && (
              <>
                <Header logo={logo} />
                <img src={icon_session_expired} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <h1 className="card-title fw-bold text-white mt-5">DOCUMENTO EXPIRADO</h1>
                <h5 className="card-text text-light">Este documento teve seu prazo de assinatura expirado no sistema. Procure a empresa que precisa da sua assinatura.</h5>
              </>
            )}
            {(arrestWarrant || personPoliticallyExports) && (
              <>
                <Header logo={logo} />
                <img src={icon_error_data} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <h1 className="card-title fw-bold text-white mt-5">DESCULPE, SEU CPF NÃO ESTÁ ELEGÍVEL PARA ESTA OPERAÇÃO</h1>
                <h5 className="card-text text-light">Procure a pessoa ou instituição que precisa da sua assinatura para continuar o processo.</h5>
              </>
            )}
            {sessionExpired && (
              <>
                <img src={icon_session_expired} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <h1 className="card-title fw-bold text-white mt-5">SESSÃO EXPIRADA</h1>
                <h5 className="card-text text-light">Você excedeu o tempo limite nesta tela. Recomece no botão abaixo.</h5>
                <div className="row mt-5 justify-content-center">
                  <div className="col-12 d-grid mt-5 ">
                    <button type="button" className="btn btn-primary btn-sm fw-bold" onClick={reloadSystem}>
                      REINICIAR
                    </button>
                  </div>
                </div>
              </>
            )}
            {authenticationNotPermited && (
              <>
                <img src={icone_atencao} style={{ maxHeight: "205px" }} alt="" className="img-fluid mx-auto d-block mt-2" />
                <h1 className="card-title fw-bold text-white mt-2">AUTENTICAÇÃO JÁ REALIZADA</h1>
                {urlRedirect ? <RedirectAuthenticate urlRedirect={urlRedirect} /> : window.opener ? this.verifyPopUp() : ""}
              </>
            )}
            {inMaintenance && (
              <>
                <Header logo={logo} />
                <img src={icon_maintenance} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <h1 className="card-title fw-bold text-white mt-5">SISTEMA EM ATUALIZAÇÃO</h1>
                <h5 className="card-text text-light">Estamos trabalhando para reestabelecer os nossos serviços o mais rápido possível. Por favor, tente mais tarde.</h5>
              </>
            )}
            {selfieInvalid && (
              <>
                <img src={icon_biometric} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <h1 className="card-title fw-bold text-white mt-5">PRECISAMOS DE UMA FOTO MELHOR</h1>
                <div className="col-12 mt-3 d-grid text-center">
                  <h5 className="card-text text-light">
                    Veja se está seguindo este passo a passo:
                    <div className="container">
                      <div className="row">
                        <div className="col-md-6 offset-md-4">
                          <ol style={{ textAlign: "left" }} className="mt-2">
                            <li className="card-text text-light mb-1">Local iluminado</li>
                            <li className="card-text text-light mb-1">Celular na altura dos olhos</li>
                            <li className="card-text text-light mb-1">Nenhum objeto no rosto</li>
                          </ol>
                        </div>
                      </div>
                    </div>
                  </h5>
                </div>

                <div className="row mt-3 justify-content-center">
                  <div className="col-6 d-grid mt-5">
                    <a href={`${process.env.REACT_APP_HELP_URL}/#mediajb0o4to313`} target="_blank" className="btn btn-secondary w-100 fw-bold">
                      PRECISO DE AJUDA
                    </a>
                  </div>
                  <div className="col-6 d-grid mt-5">
                    <button className="btn btn-primary fw-bold" type="button" onClick={reloadSystem}>
                      TENTAR DE NOVO
                    </button>
                  </div>
                </div>
              </>
            )}
            {connectionInterrupted && (
              <>
                <img src={icon_block} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <h1 className="card-title fw-bold text-white mt-5">CONEXÃO INTERROMPIDA</h1>
                <h5 className="card-text text-light">Detectamos uma potencial ameaça de segurança e sua conexão foi interrompida.</h5>
                <div className="row mt-5 justify-content-center">
                  <div className="col-12 d-grid mt-5 ">
                    <button type="button" className="btn btn-primary btn-sm fw-bold" onClick={reloadSystem}>
                      REINICIAR
                    </button>
                  </div>
                </div>
              </>
            )}
            {cancel && !urlRedirect && (
              <>
                <img src={icon_doc_not_sign} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <h1 className="card-title fw-bold text-white mt-5">NÃO É POSSÍVEL CONTINUAR</h1>
                <h5 className="card-text text-light">Você precisa reiniciar o processo.</h5>
                <div className="row mt-5 justify-content-center">
                  <div className="col-12 d-grid mt-5 ">
                    <button type="button" className="btn btn-primary btn-sm fw-bold" onClick={reloadSystem}>
                      REINICIAR
                    </button>
                  </div>
                </div>
              </>
            )}
            {cancel && urlRedirect && (
              <>
                <img src={icon_block} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <h1 className="card-title fw-bold text-white mt-5">NÃO É POSSÍVEL CONTINUAR!</h1>
                {urlRedirect && <RedirectAuthenticate urlRedirect={urlRedirect} />}
              </>
            )}
            {accessCam && (
              <>
                <img src={icon_maintenance} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <h1 className="card-title fw-bold text-white mt-5">NÃO É POSSÍVEL CONTINUAR</h1>
                <h5 className="card-text text-light">Você precisa reiniciar o processo e permitir o acesso à câmera para continuar com sua identificação.</h5>
                <div className="row mt-5 justify-content-center">
                  <div className="col-12 d-grid mt-5 ">
                    <button type="button" className="btn btn-primary btn-sm fw-bold" onClick={reloadSystem}>
                      REINICIAR
                    </button>
                  </div>
                </div>
              </>
            )}
            {limitAccess && (
              <>
                <img src={icon_block} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <h1 className="card-title fw-bold text-white mt-5">LIMITE DE TENTATIVAS EXCEDIDO</h1>
                <h5 className="card-text text-light">Você atingiu o limite de tentativas. Será necessário aguardar alguns minutos e reiniciar o processo.</h5>
                <div className="row mt-5 justify-content-center">
                  <div className="row mt-3 justify-content-center">
                    <div className="col-6 d-grid mt-5">
                      <a href="https://confia.octadesk.com/kb/article/deu-erro-na-minha-biometria-facial-o-que-fazer" target="_blank" className="btn btn-primary w-100 fw-bold">
                        AJUDA
                      </a>
                    </div>
                  </div>
                </div>
              </>
            )}
            {geolocationNeeded && (
              <>
                <img src={icon_doc_not_sign} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <h1 className="card-title fw-bold text-white mt-5">NÃO É POSSÍVEL CONTINUAR</h1>
                <h5 className="card-text text-light">Você precisa permitir o acesso à sua localização para assinar o documento.</h5>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorGeneric;
